var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenYellowCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24712",
    "data-name": "Group 24712",
    transform: "translate(10053 -5076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2916",
    "data-name": "Ellipse 2916",
    transform: "translate(-10053 5076)",
    fill: "#036f0d",
    stroke: "#ffff0a",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-truck",
    "data-name": "Icon awesome-truck",
    d: "M12.573,7.093h-.322V4.914a.967.967,0,0,0-.284-.683L9.954,2.218a.967.967,0,0,0-.683-.284H8.382V.967A.967.967,0,0,0,7.415,0H.967A.967.967,0,0,0,0,.967V7.415a.967.967,0,0,0,.967.967H1.29a1.934,1.934,0,0,0,3.869,0H7.737a1.934,1.934,0,0,0,3.869,0h.967A.323.323,0,0,0,12.9,8.06V7.415a.323.323,0,0,0-.327-.322ZM3.224,9.349a.967.967,0,1,1,.967-.967A.967.967,0,0,1,3.224,9.349Zm6.448,0a.967.967,0,1,1,.967-.967A.967.967,0,0,1,9.672,9.349Zm1.612-4.191h-2.9V2.9h.889l2.013,2.013Z",
    transform: "translate(-10047 5083)",
    fill: "#ff0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenYellowCar);
export default __webpack_public_path__ + "static/media/green_yellow_car.670c0e978cba4fa8a36c635652ea03b2.svg";
export { ForwardRef as ReactComponent };